// extracted by mini-css-extract-plugin
export default {"navegacao":"Menu_navegacao__YWRV4"};